import { OrderDeliveryMethod } from '../api/Owner/getFullOwnerProductQuery';

import { orderDeliveryMethodMessages } from './messages/orderDeliveryMethodMessages';

export const getOrderDeliveryMethodMessage = (
  orderDeliveryMethod: OrderDeliveryMethod,
) => {
  return orderDeliveryMethodMessages[orderDeliveryMethod];
};
